import { doc, setDoc } from 'firebase/firestore'

export const AGGIUNGI_DATA_TUTORIAL = async (id, dati) => {
    await setDoc(doc(db, 'dateTutorial', id), dati)
    return
}
